module.exports = __webpack_public_path__ + "media/icons/key-e-863b5856.svg";